import type { RootState } from '@store/index';

export const jwtTokenSelector = (state: RootState) => state.app.jwtToken;
export const accountSelector = (state: RootState) => state.app.account;
export const accessSelector = (state: RootState) => state.app.access;
export const navOpenSelector = (state: RootState) => state.app.navOpen;
